// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

const S = {
  Container: styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    z-index: 1000;
    justify-content: center;
    align-items: center;
  `,
  Title: styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
    text-align: center;
    color: #434343;
  `,
  SubTitle: styled.div`
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    color: #434343;
  `
};

export { S as default };
